import { render, staticRenderFns } from "./listComponents.vue?vue&type=template&id=6868870c&scoped=true&"
import script from "./listComponents.vue?vue&type=script&lang=js&"
export * from "./listComponents.vue?vue&type=script&lang=js&"
import style0 from "./listComponents.vue?vue&type=style&index=0&id=6868870c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6868870c",
  null
  
)

export default component.exports